'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagVuAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.12733e-05 20H28V12H10.6667L1.12733e-05 20Z",
          fill: "#009543"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.6346 7.97594L28 8V0H1.12733e-05L10.6346 7.97594Z",
          fill: "#D21034"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.6667 12H28V8L10.6346 7.97594L13.3333 10L10.6667 12Z",
          fill: "#262626"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.12733e-05 0L13.3333 10L1.12733e-05 20V0Z",
          fill: "#262626"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.41227e-06 2.26412L-1.29441e-05 17.7157L10.6667 10L8.41227e-06 2.26412ZM1.12733e-05 3.94101V16.059L8.38939 10L1.12733e-05 3.94101Z",
          fill: "#FDCE12"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.7436 10.6667H28V9.33333H9.7436L10.6667 10L9.7436 10.6667Z",
          fill: "#FDCE12"
        }
      )
    ]
  }
);
const VpFlagVuAsset = forwardRef(FlagVuAsset);

export { VpFlagVuAsset as default };
